import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import Logo from "@/components/Logo";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-white/10 bg-[color:var(--sentinel-darker)] text-white"
    >
      <div className="container-x py-14">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="flex flex-col gap-3">
            <Logo variant="white" className="h-8" />
            <p className="max-w-md text-sm text-white/65">{t.footer.tagline}</p>
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-white/65">
            <Link to="/#how" className="hover:text-white" data-testid="footer-link-how">
              {t.nav.howItWorks}
            </Link>
            <Link to="/#faq" className="hover:text-white" data-testid="footer-link-faq">
              {t.nav.faq}
            </Link>
            <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-link-privacy">
              {t.footer.privacy}
            </Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-link-terms">
              {t.footer.terms}
            </Link>
            <Link to="/support" className="hover:text-white" data-testid="footer-link-support">
              {t.footer.support}
            </Link>
            <a href="#" className="hover:text-white" data-testid="footer-link-legal">
              {t.footer.legal}
            </a>
          </div>
        </div>
        <div className="mt-10 border-t border-dashed border-white/15 pt-6 text-xs text-white/45">
          <p className="max-w-3xl leading-relaxed">{t.footer.disclaimer}</p>
          <p className="mt-2">© {year} Cyrqle. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
